<div class="impersonate-container" *ngIf="loading">
  <div class="spinner"></div>
</div>
